import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CloseIcon from "@material-ui/icons/Close";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { useSearch } from "hook";
import React, { Children, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Select, { components } from "react-select";
import Button from "../button/Button";
import MyButton from "../MyButton";
import { SelectField } from "../SelectFields/SelectField";
import "./index.scss";
import { fontConfig } from "theme/fontConfig";
export default function MainDialog({
  content,
  subContent,
  subCon,
  typeDeceased = false,
  onAccept,
  onDecline,
  open,
  handleClose,
  closeButton,
  okButtonContent,
  noButtonContent,
  disabled,
  removeButton,
  removeNoButton = false,
  DeceasedVal,
  getTypes,
  childrenValue,
  loading = false,
  contentStyle = {},
  minHeight
}) {
  const [search, setSearch] = useState("");
  const [value, setValue] = useState("");
  const [typeData, setTypeData] = useState({
    id: "",
    name: "",
    hidden: "",
  });
  const [dClicked, setdClicked] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  //Read Me!
  // on the buttonContent prop I send what we should desplay on the button
  //if you don't it desplay yes /no like before
  //fixed for the fillter.
  const onChange = (e) => {
    setTypeData({ id: e.value?.id, name: e.label, hidden: e.value?.hidden });
    setValue(e.label);
  };
  const options = getTypes?.map((item) => ({
    value: { id: item?._id, hidden: item?.hidden },
    label: item?.type,
  }));
  const onDropDownClick = () => {
    setdClicked("clicked");
  };

  useEffect(() => {
    if (!open) {
      setdClicked("");
    }
  }, [open]);
  return (
    <div >
      <Dialog open={open} onClose={handleClose}  PaperProps={{
    style: {
      minHeight: minHeight || "auto", 
    
    },
  }}>
        <div
          className={dClicked === "clicked" ? "reversal-modal" : ""}
          style={{
            position: "relative",
           
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              color: "black",
              // border: "5px solid #1c0202",
              borderRadius: "51%",
              // padding: "6px 10px",
              cursor: "pointer",
            }}
            onClick={onDecline}
          >
            <CloseIcon />
          </div>
          <DialogContent
            style={{
              backgroundColor: "#FFFFFF",
              paddingTop: "40px",
            }}
          >
            <DialogContentText
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: "20px",
                fontWeight: "400",
                width: "500px",
                color: "black",
                paddingBottom: `10px`,
                paddingTop: "8px",
                fontFamily: fontConfig.DialogDialogContentTextFont.family,
                // display: "flex",
                // justifyContent: "left",
                // fontSize: "14px",
                // fontWeight: "700",
                // color: "black",
                // width: "550px",
                // wordSpacing: "7px",
                // padding: "0px 30px",
                // marginTop: "1rem",
                ...contentStyle,
              }}
            >
              {content}
            </DialogContentText>
          </DialogContent>
          {subContent && (
            <DialogContentText
              style={{
                // // display: "flex",
                // justifyContent: "left",
                // textAlign: "center",
                // fontSize: "14px",
                // fontWeight: "700",
                // color: "black",
                // width: "550px",
                // wordSpacing: "7px",
                // padding: "0px 30px",
                // marginTop: "1rem",
                // fontFamily: "poppins",

                // display: "flex",
                textAlign: "center",
                // justifyContent: "left",
                fontSize: "16px",
                fontWeight: "400",
                color: "black",
                width: "550px",
                wordSpacing: "4px",
                padding: "0px 30px",
                marginTop: "2rem",
                fontFamily: fontConfig.DialogDialogContentTextFont.family,
              }}
            >
              {subContent}
            </DialogContentText>
          )}

          {typeDeceased && (
            <div>
              <p
                style={{
                  display: "flex",
                  justifyContent: "left",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "black",
                  width: "550px",
                  wordSpacing: "4px",
                  padding: "0px 30px",
                  marginTop: "2rem",
                  marginBottom: "1rem",
                  fontFamily: fontConfig.DialogMainDialogTextFont.family,
                }}
              >
                Type{" "}
                <span
                  style={{
                    fontWeight: "800",
                    padding: "0px 10px",
                  }}
                >
                  DECEASED
                </span>{" "}
                to confirm
              </p>
              {childrenValue}
            </div>
          )}
          {!removeButton && (
            <div
              className="footer"
              style={{
                display: Array.isArray(getTypes) ? "" : "flex",
                justifyContent: Array.isArray(getTypes) ? "" : "center",
                margin: "20px",
              }}
            >
              {Array.isArray(getTypes) ? (
                <span onClick={onDropDownClick}>
                  <Dropdown
                    options={options}
                    onChange={onChange}
                    value={typeData?.name}
                    placeholder="Select an option"
                  />

                  <div style={{
                    position: "absolute",
                    left: loading ? "40%" : "80%",
                    top: loading ? '60%' : "80%",
                    margin: '4rem 0rem',
                  }}>
                    <MyButton
                      onClick={() =>
                        onAccept(typeData?.id, typeData?.name, typeData?.hidden)
                      }
                      disabled={loading}
                      content={"Yes"}
                      style={{

                        //   border: "none",
                        //   width: "fit-content",
                        // margin: "0px 41px 0px 131px",
                      }}
                    />
                  </div>
                </span>
              ) : (
                // getTypes.map((type) => (
                //   <MyButton
                //     onClick={() => onAccept(type._id, type.type, type.hidden)}
                //     content={type.type}
                //     style={{
                //       border: "none",
                //       width: "fit-content",
                //       margin: "5px",
                //     }}
                //   />
                // ))
                <>
                  {typeDeceased === false ? (
                    <Button
                      variant="primary"
                      size="md"
                      onClick={onAccept}
                      style={{
                        border: "none",
                        width: "fit-content",
                        margin: "5px",
                        minWidth: "100px",
                      }}
                      loading={loading}
                      disabled={disabled}
                    >
                      {okButtonContent || "Confirm"}
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      size="md"
                      onClick={
                        DeceasedVal === "DECEASED" || DeceasedVal === "deceased"
                          ? onAccept
                          : ""
                      }
                      disabled={
                        DeceasedVal === "DECEASED" || DeceasedVal === "deceased"
                          ? false
                          : true
                      }
                      style={{
                        border: "none",
                        width: "fit-content",
                        margin: "5px",
                        minWidth: "100px",
                      }}
                    >
                      {"Confirm"}
                    </Button>
                  )}
                </>
              )}
              {/* {!removeNoButton && typeDeceased === false && (
                <MyButton
                  onClick={onDecline}
                  content={noButtonContent || closeButton || "No"}
                  type="secondary"
                  style={{
                    width: "fit-content",
                    margin: "5px",
                    display: disabled ? "none" : "",
                  }}
                />
              )} */}
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}

